import { createAction, createReducer } from "@reduxjs/toolkit";

export const setUser = createAction("SET_USER");
export const userLogout = createAction("USER_LOGOUT");
export const addFavorites = createAction("ADD_FAVORITES");
export const removeFavorite = createAction("REMOVE_FAVORITE");

const initialState = {
  id: null,
  email: null,
  name: null,
  lastName: null,
  admin: null,
  properties: [],
};

const userReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setUser, (state, action) => {
      // Retornar reemplaza todo el estado actual por el nuevo payload
      return action.payload;
    })
    .addCase(userLogout, (state, action) => {
      // Retornar un objeto vacío limpia el estado
      return {};
    })
    .addCase(addFavorites, (state, action) => {
      // Gracias a la nueva sintaxis (Immer), podemos "mutar" la propiedad directamente
      // (En la versión anterior tenías un pequeño bug aquí, ya que devolvías un array en lugar del objeto completo)
      state.properties = state.properties.concat(action.payload);
    })
    .addCase(removeFavorite, (state, action) => {
      // Mutamos directamente el array filtrado
      state.properties = state.properties.filter(
        (fav) => fav.id !== action.payload.id
      );
    });
});

export default userReducer;